import React, { useContext, useState } from 'react';
import { Box, Button, FormControl, Grid, MenuItem, Select, TextField } from "@mui/material";
import { Field, Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext'; // Ensure correct import path

const countries = [
  { code: 'ET', label: 'Ethiopia', areaCode: '251' },
  { code: 'US', label: 'United States', areaCode: '1' },
  { code: 'CA', label: 'Canada', areaCode: '2' },
  { code: 'GB', label: 'United Kingdom', areaCode: '44' },
  { code: 'AU', label: 'Australia', areaCode: '61' },
];

const NoDropdownArrow = () => <span />;

const NewCustomer = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const { currentuser, base_url } = useContext(AuthContext);
  const [pdfFile, setPdfFile] = useState(null); // State to hold the PDF file

  const config = {
    headers: {
      'Authorization': `Bearer ${currentuser.accessToken}`
    },
    responseType: 'blob',
  };

  const registerUser = async (values) => {
    // console.log(currentuser?.token);
    const formData = new FormData();

    // Append user data to formData
    formData.append('firstName', values.firstName);
    formData.append('middleName', values.middleName);
    formData.append('lastName', values.lastName);
    formData.append('email', values.email);
    formData.append('country', values.country);
    formData.append('region', values.region);
    formData.append('phoneNumber', values.phoneNumber);
    formData.append('password', values.password);
    formData.append('confirmpassword', values.confirmpassword);

    // Append the PDF file if available
    if (pdfFile) {
      formData.append('pdf', pdfFile, pdfFile.name);
    }

    try {
      const response = await axios.post(`${base_url}/ethioglobal/register-user`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${currentuser?.token}`
         },
      });
      console.log(response);
      alert("User registered successfully!");
    } catch (error) {
      console.error("Error registering user", error);
      alert("Failed to register user.");
    }
  };

  return (
    <Box m="20px">
      <Header subtitle="Create a New User" />
      <Formik
        onSubmit={registerUser}
        initialValues={initialValues}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box component="div" noValidate sx={{ mt: 3 }}>
              <Grid container spacing={2} xs={10}>
                <Grid item xs={12} sm={6}>
                  <Field
                    as={TextField}
                    required
                    fullWidth
                    id="firstName"
                    label="First Name"
                    name="firstName"
                    autoComplete="username"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.firstName && Boolean(errors.firstName)}
                    helperText={touched.firstName && errors.firstName}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    as={TextField}
                    required
                    fullWidth
                    id="middleName"
                    label="Middle Name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.middleName}
                    name="middleName"
                    error={!!touched.middleName && !!errors.middleName}
                    helperText={touched.middleName && errors.middleName}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    as={TextField}
                    required
                    fullWidth
                    id="lastName"
                    label="Last Name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.lastName}
                    name="lastName"
                    error={!!touched.lastName && !!errors.lastName}
                    helperText={touched.lastName && errors.lastName}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    as={TextField}
                    required
                    fullWidth
                    id="country"
                    label="Country"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.country}
                    name="country"
                    error={!!touched.country && !!errors.country}
                    helperText={touched.country && errors.country}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    as={TextField}
                    required
                    fullWidth
                    id="region"
                    label="Region"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.region}
                    name="region"
                    error={!!touched.region && !!errors.region}
                    helperText={touched.region && errors.region}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    as={TextField}
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                  />
                </Grid>
                <Grid item xs={12} container spacing={2}>
                  <Grid item xs={4}>
                    <FormControl fullWidth required>
                      <Select
                        labelId="country-select-label"
                        id="country"
                        name="country"
                        placeholder="251"
                        value={values.code}
                        defaultValue="251"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        IconComponent={NoDropdownArrow}
                        error={touched.country && Boolean(errors.country)}
                      >
                        {countries.map((country) => (
                          <MenuItem key={country.code} value={country.areaCode}>
                            {country.areaCode}
                          </MenuItem>
                        ))}
                      </Select>
                      {touched.country && errors.country && (
                        <div style={{ color: 'red' }}>{errors.country}</div>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={8}>
                    <Field
                      as={TextField}
                      required
                      fullWidth
                      id="phoneNumber"
                      label="Phone Number"
                      name="phoneNumber"
                      autoComplete="tel"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.phoneNumber && Boolean(errors.phoneNumber)}
                      helperText={touched.phoneNumber && errors.phoneNumber}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    as={TextField}
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="new-password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.password && Boolean(errors.password)}
                    helperText={touched.password && errors.password}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    as={TextField}
                    required
                    fullWidth
                    name="confirmpassword"
                    label="Confirm Password"
                    type="password"
                    id="confirmpassword"
                    autoComplete="new-password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.confirmpassword && Boolean(errors.confirmpassword)}
                    helperText={touched.confirmpassword && errors.confirmpassword}
                  />
                </Grid>
              </Grid>

              {/* Document Upload Section */}
              <Grid item xs={12} sx={{ mt: 3 }}>
                <input
                  accept="application/pdf"
                  id="document"
                  name="document"
                  type="file"
                  onChange={(event) => {
                    const file = event.currentTarget.files[0];
                    setPdfFile(file); // Store the selected file in state
                    setFieldValue("document", file); // Optionally set it in Formik's state
                  }}
                  onBlur={handleBlur}
                  style={{ display: 'none' }}
                />
                <label htmlFor="document">
                  <Button variant="link" component="span" color="primary" sx={{ textTransform: 'none', '&:hover': {backgroundColor: 'darkgray'} }}>
                    {values.document ? values.document.name : "Select user document (pdf)"}
                  </Button>
                </label>
                {touched.document && errors.document && (
                  <div style={{ color: 'red' }}>{errors.document}</div>
                )}
              </Grid>
              <Button type="submit" color="primary" variant="contained" sx={{ top: 30 }}>
                Create New User
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

// Regular expression for phone number validation
const phoneRegExp =
  /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;

// Updated validation schema
const checkoutSchema = yup.object().shape({
  firstName: yup.string().required("First Name is required"),
  middleName: yup.string().required("Middle Name is required"),
  lastName: yup.string().required("Last Name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  country: yup.string().required("Country is required"),
  region: yup.string().required("Region is required"),
  phoneNumber: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("Phone number is required"),
  password: yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),
  confirmpassword: yup
    .string()
    .oneOf([yup.ref('password'), null], "Passwords must match")
    .required("Confirm Password is required"),
  document: yup
    .mixed()
    .required("A document is required")
    .test("fileType", "Only PDFs are allowed", (value) => {
      return value && value.type === "application/pdf";
    }),
});

// Updated initial values
const initialValues = {
  firstName: "",
  middleName: "",
  lastName: "",
  email: "",
  country: "",
  region: "",
  phoneNumber: "",
  password: "",
  confirmpassword: "",
  document: null, // For the uploaded document
  code: "251", // Default country code
};

export default NewCustomer;